

module.exports = {
    // A helper function to capatialize first character of all words. used in titles
    // delimeter: a single space
    // retain the captical case in the sentence
    CapitalizeFirstLetter: function(title) {
        let splitStr = title.split(' ');
        for (let i = 0; i < splitStr.length; i++) {
            // You do not need to check if i is larger than splitStr length, as your for does that for you
            // Assign it back to the array
            splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
        }
        // Directly return the joined string
        return splitStr.join(' ');
    },

    text_truncate: function(str, length, ending) {
        if (length == null) {
            length = 100;
        }
        if (ending == null) {
            ending = '...';
        }
        if (str.length > length) {
            return str.substring(0, length - ending.length) + ending;
        } else {
            return str;
        }
    },
    money_convert(amount, unit) {
        if (unit == "m") {
            let str = amount.toString()
            str='$'+str.substring(0, str.length-6) + 'm'
            return str
        }
    }
};





// WEBPACK FOOTER //
// ./src/util/StringUtil.js